import { Component, Input } from "@angular/core"
import { Attribute } from "../../models/attribute.model"

@Component({
    selector: "app-attributes",
    templateUrl: "./attributes.component.html",
    styleUrls: ["./attributes.component.less"],
})
export class AttributesComponent {
    @Input() public attributions: Attribute[] = []
}
